import React, { useState } from 'react'
import {useRecoilState, useRecoilValue} from "recoil";
import {adminState, fetchAPIResponseSelector} from "../store/user.atom";
import {toast} from "react-toastify";
import {AdminDTO} from "../dtos/admin.dto";

type Props = {}

const Login = (props: Props) => {
    const [admin, setAdmin] = useRecoilState(adminState);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState<string | null>(null);
    const fetchAPIResponse = useRecoilValue(fetchAPIResponseSelector);

    const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();

      if (!username || !password) {
        toast.error('Please enter both email and password');
        return;
      }

      try {
          const admin = await fetchAPIResponse<AdminDTO>("/admins/login", {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              },
              body: JSON.stringify({
                  email: username,
                  password
              })
          });

          setAdmin(admin.data);
          localStorage.setItem("zburgerhouse_admin", JSON.stringify(admin.data)) //todo move this to a selector
      } catch (e) {
          toast.error((e as Error).message)
      } finally {

      }
    };

    return (
      <div className="min-h-screen w-full flex items-center justify-center bg-canvas px-4 py-12">
        <div className="w-full max-w-sm">
          {/* Brand lockup on its own dark chip — echoes the sidebar */}
          <div className="flex flex-col items-center">
            <div className="rounded-2xl bg-ink px-8 py-6 shadow-lift">
              <img src="/ZBH_logo_white.png" alt="zBurgerHouse" className="h-9 w-auto opacity-95" />
            </div>
            <p className="zbh-eyebrow mt-5">Kitchen Console</p>
            <h1 className="mt-1 font-display text-2xl font-bold text-ink">Sign in to continue</h1>
          </div>

          <div className="zbh-card mt-7 p-7">
            {error && <div className="mb-4 rounded-lg bg-red/10 px-3 py-2 text-sm text-red">{error}</div>}
            <form className="space-y-5" onSubmit={handleLogin}>
              <div>
                <label htmlFor="email" className="zbh-label">Email</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="zbh-input"
                  placeholder="you@zburgerhouse.com"
                />
              </div>
              <div>
                <label htmlFor="password" className="zbh-label">Password</label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="zbh-input"
                  placeholder="••••••••"
                />
              </div>
              <button type="submit" className="zbh-btn-accent w-full">
                Sign in
              </button>
            </form>
          </div>
          <p className="mt-6 text-center text-xs text-categoriesTextColor">zBurgerHouse · Zahle · Berdawni</p>
        </div>
      </div>
    );
}

export default Login
